import { render, staticRenderFns } from "./configurationSecond.vue?vue&type=template&id=6263c1e4&scoped=true&"
import script from "./configurationSecond.vue?vue&type=script&lang=js&"
export * from "./configurationSecond.vue?vue&type=script&lang=js&"
import style0 from "./configurationSecond.vue?vue&type=style&index=0&id=6263c1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6263c1e4",
  null
  
)

export default component.exports